import APIService from '@/services/APIService';
import APIDadataService from '@/services/APIDadataService';

export default {
  /**
   * Получить список пользователей
   * @returns {Promise<AxiosResponse<T>>}
   */
  getUserList() {
    return APIService.get('/users');
  },

  /**
   * Получить список констант приложения
   *
   * @returns {Promise<AxiosResponse<T>>}
   */
  getResources() {
    return APIService.get('/resources');
  },

  /**
   * Загрузить файл на сервер
   * @param data
   */
  uploadFiles(data) {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    return APIService.post('/uploads', data, config);
  },

  /**
   * Получить список направленностей программ
   * https://gitlab.pfdo.ru/pfdo/pfdo/wikis/Directory
   */
  getDirections(params = {}) {
    return APIService.get('https://apidir.pfdo.ru/v1/directory-program-directions', { params });
  },

  /**
   * Получить список видов деятельности программ
   * https://gitlab.pfdo.ru/pfdo/pfdo/wikis/Directory
   */
  getActivities(params) {
    return APIService.get('https://apidir.pfdo.ru/v1/directory-program-activities', { params });
  },

  /**
   * Получить средства обучения
   * https://gitlab.pfdo.ru/pfdo/pfdo/wikis/Directory
   */
  getLearningTools(params) {
    return APIService.get('https://apidir.pfdo.ru/v1/directory-learning-tools', { params });
  },

  /**
   * Получить список учителей организации
   * @param params
   * @returns {Promise<AxiosResponse<any>>}
   */
  getTeachers(params = {}) {
    return APIService.get('/teachers', { params });
  },

  /**
   * Получить список возможных в всистеме часовых поясов
   * @returns {Promise<AxiosResponse<any>>}
   */
  /**
   * Получить уровни образования педагогов
   * https://gitlab.pfdo.ru/pfdo/pfdo/wikis/Directory
   */
  getTeacherLevels() {
    return APIService.get('https://apidir.pfdo.ru/v1/teacher-levels');
  },
  /**
   * Получить список типов наград
   * https://gitlab.pfdo.ru/pfdo/pfdo/wikis/Directory
   */
  getAwardTypes() {
    return APIService.get('https://apidir.pfdo.ru/v1/award-types');
  },

  getDadataAddress(params) {
    return APIDadataService.post('/suggest/address', params);
  },
  regions(params) {
    return APIService.get('/regions', { params });
  },
  municipalities(params) {
    return APIService.get('/municipalities', { params });
  },
};
